<template>
	<div>
		<!-- hide for caseclub -->
		<!-- <BaseActionBar v-if="isAdmin" :items="actions" /> -->

		<BaseTable
			:is-loading="isLoading"
			:pagination="pagination"
			:fields="CHANNEL_TABLE_FIELDS"
			:items="tableData"
			:hide-columns="['id']"
			name-route="ChannelSingle"
			striped
			hover
			fixed
			clickable-rows
			class="table-custom"
			@onPaginationClick="handlePageChange"
			@onRowClick="handleRowClick"
		>
			<template #no-items-view>
				<div class="empty-table-element">
					<p class="subtitle">
						{{ $t('message.not_found_user_list') }}
					</p>
				</div>
			</template>
		</BaseTable>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { cleanObject, cloneDeep } from '../helpers/utils';
import { CHANNEL_TABLE_FIELDS } from '../enums/channel';
import { ROUTER_NAME } from '../enums/router';

export default {
	name: 'UserList',

	data() {
		return {
			CHANNEL_TABLE_FIELDS,
			actions: [
				{
					to: { name: ROUTER_NAME.CHANNEL_CREATE },
					icon: ['far', 'plus'],
					color: 'secondary',
					text: this.$t('button.create_channel'),
				},
			],
			query: {
				page: this.$route.query.page || null,
			},
		};
	},

	computed: {
		...mapState('channelList', {
			isLoading: 'isLoading',
			pagination: 'pagination',
		}),
		...mapGetters('channelList', {
			tableData: 'tableData',
		}),
		...mapGetters('me', {
			isAdmin: 'isAdmin',
		}),
	},

	created() {
		this.fetchData();
	},

	methods: {
		...mapActions('channelList', {
			getChannels: 'getChannels',
		}),
		fetchData() {
			this.getChannels();
		},
		handleRowClick(id) {
			this.$router.push({ name: ROUTER_NAME.CHANNEL_SINGLE, params: { id } });
		},
		handlePageChange(pageNum) {
			this.query.page = pageNum;
			this.updateUrl();
		},
		updateUrl() {
			const query = cleanObject(cloneDeep(this.query));
			this.$router.push({ query }).catch(() => {});
		},
	},
};
</script>
